import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import style from './style.css';

export default class MainLayout extends React.Component {
    static propTypes = {
        banner: PropTypes.string,
        children: PropTypes.node,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: 'container',
    };

    render() {
        return (
            <div className={style.wrapper}>
                <Header className={this.props.className} noBorder />
                <div className={style.body}>
                    {this.props.banner && (
                        <div className={style.banner}>
                            <div className="container">Online Training</div>
                        </div>
                    )}
                    <div className={this.props.className}>{this.props.children}</div>
                </div>

                <div className={style.footer}>
                    <Footer className={this.props.className} />
                </div>
            </div>
        );
    }
}
